import { Component, OnInit } from '@angular/core';
import { InvoiceService } from '../../../data/invoice.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { TableColumnService } from '../../shared/services/table-column.service';
import { invoiceTableRequest } from '../../../store/invoice-table/invoice-table.actions';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { InvoiceData } from './invoice.data';
import { DocumentService } from '../../shared/services/document.service';
import { selectDocumentState } from '../../../store/interface/interface.state';
import { DocumentStateEnum } from '../../../enum/document-state.enum';
import { InvoiceTableService } from '../../shared/tables/invoice-table.service';
import { paymentStart } from '../../../store/payment/payment.actions';
import { MatPaginator } from '@angular/material/paginator';
import { MatButton } from '@angular/material/button';
import { DocumentLinkComponent } from '../../shared/document-link/document-link.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef,
    MatRow } from '@angular/material/table';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AsyncPipe } from '@angular/common';
import { selectRole } from '../../../store/profile/profile.state';
import { RoleEnum } from '../../../enum/role.enum';
import { MatDialog } from '@angular/material/dialog';
import { InvoiceViewComponent } from '../invoice-view/invoice-view.component';
import { Invoice } from '../../../models/invoice';
import { InvoiceColumnEnum } from '../../../enum/invoice-column.enum';

@Component({
    selector: 'app-invoice-table',
    templateUrl: './invoice-table.component.html',
    styleUrls: ['./invoice-table.component.scss'],
    imports: [MatProgressSpinner, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCheckbox, MatCellDef, MatCell, MatSortHeader, DocumentLinkComponent, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatButton, MatPaginator, AsyncPipe]
})
export class InvoiceTableComponent implements OnInit {

    constructor(private store: Store<AppState>, private invoiceService: InvoiceService,
                private tableColumnService: TableColumnService, public table: InvoiceTableService,
                private documentService: DocumentService, private dialog: MatDialog) {
    }

    documentsBusy$: Observable<boolean> = this.store.select(selectDocumentState).pipe(
        map(state => state !== DocumentStateEnum.NONE)
    );
    showMakePayment$ = this.store.select(selectRole(RoleEnum.CREDIT_CARD_PAYMENTS));

    dataSource = new InvoiceData(this.table.currentPageEntries$);

    ngOnInit(): void {
        this.store.dispatch(invoiceTableRequest());
        
        // Add button handler to invoice reference column
        const referenceColumn = this.table.columnDefinitions.find(col => col.id === InvoiceColumnEnum.INVOICE_REFERENCE);
        if (referenceColumn) {
            referenceColumn.button = (invoice: Invoice) => this.openInvoiceView(invoice);
        }
    }

    print(): void {
        this.table.selection$.pipe(take(1)).subscribe(selection => {
            this.documentService.openInvoices(selection);
        });
    }

    makePayment(): void {
        this.store.dispatch(paymentStart());
    }

    openInvoiceView(invoice: Invoice): void {
        this.dialog.open(InvoiceViewComponent, { data: { invoice } });
    }

}
